import React, { useEffect, useRef } from "react";
import { googleSession } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export const AuthCallback = () => {
  const { loginWithToken } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const finish = (path) => { window.history.replaceState({}, "", path); window.location.reload(); };
    if (!sid) { finish("/"); return; }
    googleSession(sid)
      .then((data) => {
        loginWithToken(data.token, data.user, "signed_in");
        const m = data.migrated ? ` ${data.migrated} previous report${data.migrated > 1 ? "s" : ""} saved.` : "";
        toast.success(`Signed in as ${data.user?.name || data.user?.email}.` + m);
        window.history.replaceState({}, "", "/");
        window.location.reload();
      })
      .catch(() => { toast.error("Google sign-in failed. Please try again."); finish("/"); });
  }, [loginWithToken]);

  return (
    <div className="h-screen flex items-center justify-center gap-3 text-muted-foreground">
      <Loader2 className="animate-spin" /> Signing you in…
    </div>
  );
};
